import { EventEmitter } from 'events';
import Api from '../services/accountapi';
import * as moment from 'moment';
import TerminalApi from '../services/terminalapi';
import TransnationalTerminalApi from '../services/gotnpayTerminalapi';

import reportsStore from '../stores/report-store';

class AccountStore extends EventEmitter {
    constructor() {
        super();
        this.prefix = 'ACCOUNT_STORE_';
    }
    
    ChargeJumper = (id, payload) => {
        console.log('in accouont store charge jumper');
        return new Promise((resolve, reject) => {
            Api.ChargeJumper(id, payload).then((r) => {
                if (r.status == 200) {
                    //var activeLoadDisplay = this.transformLoad(r.data);
                    //var newActivity = "Load " + r.data.loadNum + " created";
                    //this.emitResults(newActivity, 'newActivity');
                    //this.emitResults(activeLoadDisplay,'createLoad');  
                    this.emitResults({ id: id, dailyActivity: r.data.dailyActivity }, 'chargeAdded');
                    // this.emitResults(true, 'chargeCompleted');
                    reportsStore.setDropzoneTodayActivity(r.data.summary);
                    resolve(r.data);

                    //console.log('after recording charge jumper');
                }
                else if (r.status === 500 || r.status === 404) {
					this.emitResults(true, 'warningEvent');
					resolve(false);
				}
                else {
                    // this.emitResults(false, 'chargeCompleted');
                    this.emitError({ message: 'ChargeJumper could not be created, please contact support.' });
                    resolve(false);
                }
            })
                .catch((err) => {
                    // this.emitResults(false, 'chargeCompleted');
                    this.emitError({ message: 'Incomplete or Invalid data present' });
                    reject(err);
                });
        });
    }
    TransnationalTerminalTransactionSearch = (searchBody) => {
        return new Promise((resolve, reject) => {
            TransnationalTerminalApi.searchTransaction(searchBody).then((r) => {
                if (r.status == 200) {
                    //var activeLoadDisplay = this.transformLoad(r.data);
                    //var newActivity = "Load " + r.data.loadNum + " created";
                    //this.emitResults(newActivity, 'newActivity');
                    //this.emitResults(activeLoadDisplay,'createLoad');
                    //console.log(r.data);
                    this.emitResults(true, 'searchedAgain');
                    resolve(r.data);
                } else if (r.status === 500 || r.status === 404) {
                    this.emitResults(true, 'warningEvent');
                    resolve(false);
                } else {
                    // this.emitResults(false, 'chargeCompleted');
                    this.emitError({ message: 'ChargeJumper could not be created, please contact support.' });
                }
            })
                .catch((err) => {
                    this.emitResults(false, 'chargeCompleted');
                    this.emitError({ message: 'Incomplete or Invalid data present' });
                    reject(err);
                });
        });
    }
    TerminalAuthorizeAndCapture = (type, amount) => {
        return new Promise((resolve, reject) => {
            process.env.NODE_TLS_REJECT_UNAUTHORIZED = '0';
            TerminalApi.AuthorizeAndCapture(type, amount).then((r) => {
                if (r.status == 200) {
                    //var activeLoadDisplay = this.transformLoad(r.data);
                    //var newActivity = "Load " + r.data.loadNum + " created";
                    //this.emitResults(newActivity, 'newActivity');
                    //this.emitResults(activeLoadDisplay,'createLoad');
                    process.env.NODE_TLS_REJECT_UNAUTHORIZED = undefined;
                    this.emitResults(true, 'chargeCompleted');
                    resolve(r.data);
                } else if (r.status === 500 || r.status === 404) {
					this.emitResults(true, 'warningEvent');
					resolve(false);
				} else {
                    // this.emitResults(false, 'chargeCompleted');
                    this.emitError({ message: 'ChargeJumper could not be created, please contact support.' });
                }
            })
                .catch((err) => {
                    this.emitResults(false, 'chargeCompleted');
                    this.emitError({ message: 'Incomplete or Invalid data present' });
                    reject(err);
                });
        });
    }

    AddItemForTandemStudent = (id, payload) => {
        return new Promise((resolve, reject) => {
            Api.AddItemForTandemStudent(id, payload).then((r) => {
                if (r.status == 200) {
                    //console.log(r.data);

                    //var activeLoadDisplay = this.transformLoad(r.data);
                    //var newActivity = "Load " + r.data.loadNum + " created";
                    var dailyActivity = r.data.dailyActivity;
                    dailyActivity.isTandemStudent = true;
                    dailyActivity.name = "tandem student";
                    this.emitResults({ id: id, dailyActivity: dailyActivity }, 'itemsAdded');
                    //console.log(r.data.summary);
                    reportsStore.setDropzoneTodayActivity(r.data.summary);
                    //this.emitResults(activeLoadDisplay,'createLoad');  
                } else if (r.status === 500 || r.status === 404) {
					this.emitResults(true, 'warningEvent');
					resolve(false);
				} else {
                    this.emitError({ message: 'Item could not be created, please contact support.' });
                }
            })
                .catch((err) => {
                    this.emitError({ message: 'Incomplete or Invalid data present' });
                    reject(err);
                });
        });
    }

    AddItem = (id, payload) => {
        return new Promise((resolve, reject) => {
            Api.AddItem(id, payload).then((r) => {
                if (r.status == 200) {
                    //console.log(r.data);

                    //var activeLoadDisplay = this.transformLoad(r.data);
                    //var newActivity = "Load " + r.data.loadNum + " created";
                    this.emitResults({ id: id, dailyActivity: r.data.dailyActivity }, 'itemsAdded');
                    //console.log(r.data.summary);
                    reportsStore.setDropzoneTodayActivity(r.data.summary);
                    //this.emitResults(activeLoadDisplay,'createLoad');  
                } else if (r.status === 500 || r.status === 404) {
					this.emitResults(true, 'warningEvent');
					resolve(false);
				} else {
                    this.emitError({ message: 'Item could not be created, please contact support.' });
                }
            })
                .catch((err) => {
                    this.emitError({ message: 'Incomplete or Invalid data present' });
                    reject(err);
                });
        });
    }
    TransnationalTerminalTransaction = (amount, orderId) => {
        return new Promise((resolve, reject) => {
            TransnationalTerminalApi.postTransaction(amount, orderId).then((r) => {
                if (r.status == 200) {
                    //var activeLoadDisplay = this.transformLoad(r.data);
                    //var newActivity = "Load " + r.data.loadNum + " created";
                    //this.emitResults(newActivity, 'newActivity');
                    //this.emitResults(activeLoadDisplay,'createLoad');
                    this.emitResults(true, 'chargeCompleted');
                    resolve(r.data);
                } else if (r.status === 500 || r.status === 404) {
                    this.emitResults(true, 'warningEvent');
                    resolve(false);
                } else {
                    // this.emitResults(false, 'chargeCompleted');
                    this.emitError({ message: 'ChargeJumper could not be created, please contact support.' });
                }
            })
                .catch((err) => {
                    this.emitResults(false, 'chargeCompleted');
                    this.emitError({ message: 'Incomplete or Invalid data present' });
                    reject(err);
                });
        });
    }

    DeleteItem = (jumperId, itemId) => {
        return new Promise((resolve, reject) => {
            Api.DeleteItem(jumperId, itemId).then((r) => {
                if (r.status == 200) {
                    //console.log(r.data);

                    //var activeLoadDisplay = this.transformLoad(r.data);
                    //var newActivity = "Load " + r.data.loadNum + " created";
                    this.emitResults({ id: jumperId, dailyActivity: r.data.dailyActivity }, 'itemsAdded');
                    //console.log(r.data.summary);
                    reportsStore.setDropzoneTodayActivity(r.data.summary);
                    //this.emitResults(activeLoadDisplay,'createLoad');  
                } else if (r.status === 500 || r.status === 404) {
					this.emitResults(true, 'warningEvent');
					resolve(false);
				} else {
                    this.emitError({ message: 'Item could not be created, please contact support.' });
                }
            })
                .catch((err) => {
                    this.emitError({ message: 'Incomplete or Invalid data present' });
                    reject(err);
                });
        });
    }

    emitError = (err) => {
        var payload = { ...err };
        this.emit('ERROR', payload);
    }

    getEventPrefix = (func) => {
        return `${this.prefix}${func}`;
    }

    emitResults = (r, func) => {
        if (!r) {
            //console.log(r);
            this.emitError({ alert: true, message: 'No Slots found' });
        }
        this.setMaxListeners(1000);
        //console.log('about to emit');
        this.emit(`${this.prefix}${func}`, r);
    }
}

const accountStore = new AccountStore();
window.accountStore = accountStore;
export default accountStore;